import { classNames } from "primereact/utils";
import styles from "./SingleSectionPageLayout.module.scss";
import { RenderWhen } from "../../infrastructure/components/RenderWhen";

interface ISingleSectionPageLayoutProps {
  className?: string;
  innerClassName?: string;
  title: string | JSX.Element;
  subtitle?: string;
  maxHeight?: string;
  height?: string;
  children: JSX.Element;
}

export const SingleSectionPageLayout = ({
  className,
  innerClassName,
  title,
  subtitle,
  maxHeight = "60%",
  height = "100%",
  children,
}: ISingleSectionPageLayoutProps) => {
  return (
    <div className={classNames(styles.root, className)}>
      <div
        className={classNames(styles.root_main_container, innerClassName)}
        style={{ maxHeight: maxHeight, height: height }}
      >
        <div className={styles.root_main_container_title_container}>
          <h1 className={styles.root_main_container_title}>{title}</h1>
          <RenderWhen condition={!!subtitle}>
            <p>{subtitle}</p>
          </RenderWhen>
        </div>
        {children}
      </div>
    </div>
  );
};
